import React, { FC, useState } from "react";
import { IconColorE, IconSizeE } from "../../models/enums";
import Icon from "../Icon/Icon";
import Portal from "../Portal/Portal";
import ShareSlider from "../../sliders/ShareSlider/ShareSlider";
import DownloadSlider from "../../sliders/DownloadSlider/DownloadSlider";
import { VersionT } from "../../models/models";
import ReactPlayer from "react-player";

import styles from "./mobileVideoPreview.module.scss";
import { useLazyDownloadVersionQuery } from "../../api/projectsApi";
import downloadBlob from "../../utils/helpers/downloadBlob";

type MobileVideoPreviewPropTypes = {
  item: VersionT;
  onClose: () => void;
};

function downloadFile(link: string): void {
  const anchorElement = document.createElement("a");
  anchorElement.href = link;
  anchorElement.setAttribute("download", "");
  anchorElement.style.display = "none";
  document.body.appendChild(anchorElement);
  anchorElement.click();
  document.body.removeChild(anchorElement);
}

const MobileVideoPreview: FC<MobileVideoPreviewPropTypes> = ({
  item,
  onClose,
}) => {
  const { Name, AdId, fileFormat, PreviewDownloadUrl, Id } = item;
  const [showShareSlider, setShowShareSlider] = useState(false);
  const [showDownloadSlider, setShowDownloadSlider] = useState(false);
  const [downloadVersion] = useLazyDownloadVersionQuery();
  const [isUploading, setIsUploading] = useState(false);

  const toggleShowShareSlider = () => {
    setShowShareSlider((prev) => !prev);
  };

  const toggleShowDownloadSlider = () => {
    setShowDownloadSlider((prev) => !prev);
  };

  const handleShare = async () => {};

  const handleDownload = async () => {
    setIsUploading(true);
    const { data } = await downloadVersion({ PreviewDownloadUrl });
    downloadFile(data);
    setIsUploading(false);
  };

  return (
    <>
      <ShareSlider
        showBottomSlider={showShareSlider}
        toggleShow={() => toggleShowShareSlider()}
        handleShare={handleShare}
        name="Video"
        videoId={Id}
      />
      <DownloadSlider
        showBottomSlider={showDownloadSlider}
        toggleShow={toggleShowDownloadSlider}
        handleDownload={handleDownload}
        isUploading={isUploading}
      />
      <Portal id="root">
        <div className={styles.wrapper}>
          <div className={styles.header}>
            <div>
              <Icon
                name="close"
                onClick={onClose}
                color={IconColorE.WHITE}
                size={IconSizeE.XS}
              />
              <span>{Name}</span>
            </div>
            <div>
              <Icon
                name="download"
                color={IconColorE.WHITE}
                onClick={() => toggleShowDownloadSlider()}
              />
              <Icon
                name="share"
                color={IconColorE.WHITE}
                className={styles.shareIcon}
                onClick={() => toggleShowShareSlider()}
              />
            </div>
          </div>
          <div className={styles.playerWrapper}>
            {/*@ts-ignore*/}
            <ReactPlayer
              url={item.MobilePlaybackUrl as string}
              controls
              stopOnUnmount
              width="100%"
              height="auto"
            />
          </div>
          <div />
        </div>
      </Portal>
    </>
  );
};

export default MobileVideoPreview;
